const prefix = '@sailplay';

export const ACTIVATE_BONUSES_USAGE = `${prefix}/ACTIVATE_BONUSES_USAGE`;
export const CANCEL_BONUSES_USAGE = `${prefix}/CANCEL_BONUSES_USAGE`;

export const FETCH_GIFTS_REQUEST = `${prefix}/FETCH_GIFTS_REQUEST`;
export const FETCH_GIFTS_SUCCESS = `${prefix}/FETCH_GIFTS_SUCCESS`;
export const FETCH_GIFTS_FAILURE = `${prefix}/FETCH_GIFTS_FAILURE`;

export const ADD_TO_CART_REQUEST = `${prefix}/ADD_TO_CART_REQUEST`;
export const ADD_TO_CART_FAILURE = `${prefix}/ADD_TO_CART_FAILURE`;
